import { ApiData } from '@/types';
import { removeEmptyValues } from '@/utils/removeEmptyValues';
import { getRecentSearches, getPersonalization } from '@/utils/shapeQueryParams';

export function getApiData(apiOptions: ApiData): ApiData {

    const { dealerType = '', dealerId } = apiOptions;
    const apiData: ApiData = {
        ...apiOptions,
        dealerType: dealerType === 'single' || dealerId ? 'single' : 'multiple',
    };

    if (window?.localStorage) {

        const recentSearches = window.localStorage?.getItem('ATC_RECENT_SEARCHES');
        const peData = window.localStorage?.getItem('pe_data'); 

        if (recentSearches) {
            return {
                ...getRecentSearches(recentSearches),
                ...apiData,

            };
        }

        if (peData) {
            return {
                ...getPersonalization(peData),
                ...apiData,
            }
        }
    };

    return apiData;
};

export async function fetchDealerLot(apiData: ApiData) {
    let baseUrl = 'https://test.autotrader.com';

    const env = process.env.ENVIRONMENT;

    if (env && env.includes('production')) {
        baseUrl = 'https://www.autotrader.com';
    }

    if (apiData?.baseUrl) {
        // User specified base URL will override all others
        baseUrl = apiData.baseUrl;
    }

    const { dealerType, ...query } = getApiData(apiData);

    const response = await fetch(baseUrl + `/rest/lsc/dealerlot/v2/${dealerType}?` + new URLSearchParams(removeEmptyValues(query)));
    const json = await response.json();

    return json;
}